<template>
    <main
      :class="brandService.getName() === Brand.HIS ? 'bg-brand-accent-light' : ''"
      class="lg:relative w-full"
    >
      <div>
        <div id="page-hero" class="w-full py-20 text-center lg:py-28 lg:text-left">
          <div class="lg:w-1/2 lg:pr-8 relative z-30 w-auto px-6">
            <h1
              :class="brandService.getName() === Brand.HIS ? 'font-gotham-bold text-brand-secondary lg:text-4xl xl:text-6xl pb-4' : 'font-extrabold text-gray-900 lg:text-5xl xl:text-6xl'"
              class="text-4xl tracking-tight leading-none sm:text-5xl md:text-6xl ">
              {{ brandService.getHeroTitle() }}
            </h1>
            <div v-if="brandService.getName() === Brand.HIS" class="">
              <div class="flex flex-row justify-center md:justify-start items-start">
                <CheckIcon class="h-10 w-10 text-brand-primary" aria-hidden="true" />
                <span class="pt-2 pl-1 text-xl text-gray-500 font-gotham-bold">
                  Fast internet up to 1Gbps
                </span>
              </div>
              <div class="flex flex-row justify-center md:justify-start items-start">
                <CheckIcon class="h-10 w-10 text-brand-primary" aria-hidden="true" />
                <span class="pt-2 pl-1 text-xl text-gray-500 font-gotham-bold">
                  Wide range of unlimited data plans
                </span>
              </div>
              <div class="flex flex-row justify-center md:justify-start items-start">
                <CheckIcon class="h-10 w-10 text-brand-primary" aria-hidden="true" />
                <span class="pt-2 pl-1 text-xl text-gray-500 font-gotham-bold">
                  Flexible contracts
                </span>
              </div>
            </div>
            <AddressSearch :autocompleted-addresses="autocompletedAddresses" :address="address" @onAutocompletedAddressClicked="(address) => emit('onAutocompletedAddressClicked', address)" @onCheckAddressClicked="(address, done) => emit('onCheckAddressClicked', address, done)" @onAddressSearchInputted="(address) => emit('onAddressSearchInputted', address)" />
          </div>
        </div>
      </div>

      <div :class="brandService.getName() === Brand.HIS ? 'h-96' : 'h-64 sm:h-72 md:h-96'" class="relative w-auto lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
        <img :class="brandService.getName() === Brand.HIS ? 'h-full w-full object-cover overflow-visible' : 'absolute inset-0 w-full h-full object-cover'" class=" " :src="brandService.getHeroImage()" alt="" />
      </div>
    </main>
</template>

<script lang='ts' setup>
import AddressSearch from './AddressSearch.vue';
import Container from './Container.vue';
import { defineEmits, defineProps } from 'vue';
import { CheckIcon } from '@heroicons/vue/outline';
import { Address } from '@/adapters/autocompleteAddressAdapterInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const emit = defineEmits<{(e: 'onCheckAddressClicked', address: string, done: () => void): void, (e: 'onAddressSearchInputted', address: string): void, (e: 'onAutocompletedAddressClicked', address: Address): void}>();

defineProps<{
  autocompletedAddresses: Array<Address>,
  address: string
}>();

</script>
